import { Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { formatDinero } from "./../../../../../utils/formatDinero"
import { obtenerExtrasDisponiblesAction, addItemsAction, addExtraAction, resetPenalizacionAction } from "./../../../../../ducks/cambioPaqueteDuck"

const FieldExtras = () => {
    const { listaExtrasDisponibles, paquete, cantidadPasajeros, listaItems, categoriaExtra, extra, clavePaquete } = useSelector(store => store.cambiosPaquete)
    const dispatch = useDispatch()
    const [editar, setEditar] = useState(false)
    useEffect(() => {
        dispatch(obtenerExtrasDisponiblesAction({ categoriaExtra: categoriaExtra, ClavePaquete: clavePaquete }))
    }, [dispatch, categoriaExtra, clavePaquete])
    const handleChangeSelectValue = (event) => {
        dispatch(addExtraAction({ extra: event.target.value }))
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    const handleClickSave = () => {
        const extraFind = listaExtrasDisponibles.find(extraItem => extraItem.EnvioSuplementoProveedor?.IdObjeto === extra)

        if (!extraFind)
            return null

        let arraItems = listaItems.filter(item => item.id !== extra)
        let itemExtra = {
            id: extraFind.EnvioSuplementoProveedor?.IdObjeto,
            name: `${extraFind.Extra?.Nombre}`,
            price: extraFind.Suplemento,
            currency: paquete.Moneda?.Clave,
            type: "EXTRA",
            quantity: cantidadPasajeros
        }
        arraItems.push(itemExtra)
        dispatch(addItemsAction({ listaItem: arraItems }))
        dispatch(resetPenalizacionAction())
        setEditar(false)

    }
    return <div style={{ margin: "2% 0" }}>
        <Grid container>
            <Grid item xs={12}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div style={{width: "100%"}}>
                        <FormControl variant="outlined" style={{ width: "100%" }}>
                            <InputLabel id="lExtras">Extras</InputLabel>
                            <Select
                                disabled={!editar}
                                labelId="lExtras"
                                id="SExtra"
                                name="SExtra"
                                onChange={handleChangeSelectValue}
                                label="Extras"
                                value={extra}
                            >
                                <MenuItem value="0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {listaExtrasDisponibles.map((extra, index) => (
                                    <MenuItem key={extra.EnvioSuplementoProveedor?.IdObjeto} value={`${extra.EnvioSuplementoProveedor?.IdObjeto}`}>
                                        {`${extra.Extra?.Nombre} - ${formatDinero(extra.Suplemento)} ${extra.Paquete?.Moneda?.Clave}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    {
                        (!editar) &&
                        <Button
                            style={{ margin: "0 2%" }}
                            variant="contained"
                            color="primary"
                            onClick={hangdleClickEditar}
                            disabled={clavePaquete === "0"}
                        >
                            Editar
                        </Button>
                    }
                    {
                        (editar) &&
                        <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={handleClickSave}
                            >
                                Guardar
                            </Button>
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="default"
                                onClick={hangdleClickEditar}
                            >
                                Cancelar
                            </Button>
                        </div>
                    }
                </div>
            </Grid>
        </Grid>
    </div>
}
export default FieldExtras